<template>
  <div class="im-container" :style="{height: imHeight + 'px'}">
    <dialog-container :scroller-height="dialogHeight" :messages="messages" :user-message="userMessage" :is-check="isCheck" :need-service="needService"></dialog-container>
    <editor-container></editor-container>
  </div>
  <div class="mask" v-show="showMask"></div>
</template>

<script>
  import IMSDK from "@ali/tarzan-ocs/build/ocs"
  import DialogContainer from './DialogContainer'
  import EditorContainer from './EditorContainer'
  import CheckDialog from './CheckDialog'
  import configUtil from '../assets/js/configUtil'

  export default {
    props: ['imHeight', 'mailNo', 'companyCode'],
    data() {
      return {
        dialogHeight: 0,
        editorHeight: 136,
        isRobot: true,
        isEvaluation: false,
        cid: '',
        userId: '',
        userName: '',
        xcode: '',
        tt: '',
        skillGroupId: '',
        buId: '',
        messages: [],
        ocs_env: "prod",
        source_id: '1613105158',
        app_name: 'cainiao_delibird' || 'ocs',
        skill_group_id: '',
        domain_name: '//webim.daily.taobao.net',
        serviceId: '',
        mtopPrefix: configUtil.getMtopPrefix(), // mtop的前缀
        mtopSubDomain: configUtil.getMtopSubDomain(), // mtop的子域
        mtopMainDomain: configUtil.getMtopMainDomain(), // mtop的主域
        showMask: false,
        routeId:'',//路由Id 为上报增加的字段
        deptId:''
      }
    },
    watch: {
      imHeight: function() {
        this.dialogHeight = this.imHeight - this.editorHeight
      },
      isCheck: function() {

      },
      messages() {
      this.$nextTick(() => {
        document.getElementsByClassName('dialog-list')[0].scrollTop = document.getElementsByClassName('dialog-list')[0].scrollHeight;
       })
     }
    },
    methods: {
      // 机器人回答
      robotAnswer(msg) {
        var me = this;
        if (msg) {

          // 获取机器人回答
          var promise = lib.mtop.request({
            api: 'mtop.cainiao.delibird.robotservice.ask',
            v: '1.0',
            data: {
              "type": msg.click ? "2" : "0",
              "text": msg.message,
              "mailno": me.mailNo,
              "cid": me.cid,
              "uid": me.userId,
              "from": "PC",
              "cpcode": me.companyCode
            },
            appkey: '4272',
            ecode: 1,
            type: 'GET',
            dataType: 'jsonp',
            timeout: 20000
          });

          promise.then(function (resJson) {
            // 获取会话 cid
            var data = resJson.data.data;
            if (data.cid && data.cid !== '') {
              me.cid = data.cid
            }
            // 插入机器人回答
            var item = data.answerList;
            var transfer = (data.transfer == '1') ? true : false;
            me.messages.push({content: item, transfer: transfer, type: data.type, source: 'robot'});
            if (data.type == 7) {
              me.tt = +new Date();
              me.initSkillGroup();
            }
            me.scrollToBottom();
          }, function (resJson) {

          });
        }
      },
      // 聊天窗口滚动到底部
      scrollToBottom() {
        setTimeout(document.getElementsByClassName('dialog-list')[0].scrollTop = 99999999,300);
      },
      // 初始化技能组
      initSkillGroup: function() {
        var me = this;
        // 提交保存数据
        var promise = lib.mtop.request({
          api: 'mtop.cainiao.delibird.router.getskillgroupid',
          v: '1.0',
          data: {"companyCode": me.companyCode, "mailNo": me.mailNo,"robotSid": me.cid},
          appkey: '4272',
          ecode: 1,
          type: 'GET',
          dataType: 'jsonp',
          timeout: 20000
        });

        promise.then(function(resJson) {
          var data = resJson.data.data;
          if(data){
            me.skill_group_id = data.skillGroupId;
            me.buId = data.buId;
            me.routeId = data.routeId;
            me.deptId = data.deptId;
            me.initSDK();
            me.loginSDK("这是问题哟");
            me.receiveMsg();
          }
          else{
            me.messages.push({message: '获取客服技能组失败! ', source: 'info'});
          }
          me.scrollToBottom();
        }, function () {
          me.messages.push({message: '获取客服技能组失败! ', source: 'info'});
          me.scrollToBottom();
        });
      },
      // 初始化SDK
      initSDK() {
        var me = this;
        me.sdk = new IMSDK({
          env: me.ocs_env,
          sourceId: me.source_id,
          appName: me.app_name,
          loginType: 3,
          userType: 1,
          xcode:{
            userId: me.isCheck.userId,
            userName: me.isCheck.userName,
            tt: me.tt,
            xcode: me.isCheck.xcode
          }
        });
      },
      // 登录、分配客服
      loginSDK(question) {
        var me = this;
        me.sdk.login({
          userId: me.isCheck.userId,
          userName: me.isCheck.userName,
          xcode: me.isCheck.xcode,
          timestamp: me.tt,
          skillGroupId: me.skill_group_id,
          isVisitor: true,
        }).then(function () {
            me.sdk.dispatch({
            "skillGroupId" : me.skill_group_id,
            "buId": me.buId,
            "xsp_departmentid":me.deptId,
            "xsp_tenantid": me.buId,
            "bizParaMap": JSON.stringify({"serviceId": me.routeId,"routeId":me.routeId})
          }).then(function (data) {
            me.sdk.token = data.token;
            me.messages.push({message: "正在帮您转接人工…", source: 'info'});
            me.scrollToBottom();
            me.isRobot = false;
          }, function (err) {
            if (err.toString().substring(0, 5) == "Error") {
              // err = err.toString().split(": ")[1];
              err = "客服忙碌中，请拨打申通客服热线：95543";
            }
            me.messages.push({message: err, source: 'info'});
          });
        });
      },
      // 评价客服
      createNewEvaluation() {
        var me = this;
        me.sdk.createEvaluation({
          sourceId: me.sdk.sourceId,
          sid: me.sdk.sid,
          xcode: me.isCheck.xcode,
          userId: me.sdk.userId,
          userName: decodeURI(me.sdk.userName),
          tt: me.tt,
          appName: me.sdk.appName,
          skillGroupId: me.skill_group_id,
          timestamp: me.tt,
          token: me.sdk.token,
          _input_charset: "utf-8",
          loginType: 3
        }).then(function (data) {
          me.messages.push({data: data, source: 'evaluation', serviceId: me.serviceId});
        })
      },
      // 提交评价客服
      submitNewEvaluation(evaluation) {
        var me = this;
        me.sdk.submitEvaluation({
          sourceId: me.sdk.sourceId,
          sid: me.sdk.sid,
          xcode: me.isCheck.xcode,
          userId: me.sdk.userId,
          userName: decodeURI(me.sdk.userName),
          tt: me.tt,
          appName: me.sdk.appName,
          skillGroupId: me.skill_group_id,
          timestamp: me.tt,
          token: me.sdk.token,
          _input_charset: "utf-8",
          loginType: 3,
          jsonData: JSON.stringify(evaluation),
        }).then(function (data) {
        })
      },
      // 接受小二端返回消息
      receiveMsg() {
        var me = this;
        me.sdk.on('message', function (data) {
          if (data[0].cmd == "Queue") {
            me.messages.pop();
            me.messages.push({number: data[0].head.num, source: 'queue'});
          } else if (data[0].cmd == "UserJoin") {
            me.messages.pop();
            me.messages.push({name: data[0].head.name, source: 'join'});
            me.serviceId = data[0].head.name;
            me.$dispatch('service-id', me.serviceId);
            me.sendIdsToService();
          } else if (data[0].cmd == "PreMSG") {
            if (me.messages[me.messages.length-1].type != 'typing') {
              me.messages.push({message: "正在输入...", source: 'ocs', type: 'typing'});
            }
            me.$dispatch('ocs-typing');
          } else if (data[0].cmd == "MSG") {
            if (me.messages[me.messages.length-1].type == 'typing') {
              me.messages.pop();
            }
            if (data[0].head.imgTag == 'imgTag') {
              me.messages.push({img: data[0].body.trim().split("'")[1].split("'")[0], source: 'img'});
            } else {
              me.messages.push({message: data[0].body.trim(), source: 'ocs'});
            }
          }
          else if (data[0].cmd == "CAINIAO") {
            var body = JSON.parse(data[0].body.substring(1));
            if(body.cardType=="getContactUserInfo"){
              me.messages.push({content:body.content, source: 'plugin'});
            }
          } else if (data[0].cmd == "UserLeave") {
            me.$dispatch('need-leave');
          }
          me.scrollToBottom();
        });
      },
      sendIdsToService() {
        var me = this;

        var promise=lib.mtop.request({
                    api: 'mtop.cainiao.delibird.router.service.joinsessionroutinginfo',
                    v: '1.0',
                    data: {
                        "routeId": me.routeId,
                        "uid": me.sdk.userId,
                        "sid": me.sdk.sid,
                        "parent": me.cid
                    }});
        promise.then(function(resJson) {
          console.log('上报成功');
        }, function () {
           console.log('上报失败');
        });
        }
    },
    events: {
      'user-message': function(msg) {
        var me = this;
        if (me.messages.length > 0 && me.messages[me.messages.length-1].type == 'typing') {
          me.messages.pop();
        }
        me.messages.push(msg);
        me.scrollToBottom();
        // 判断机器人还是人工服务
        if(me.isRobot) {
          me.robotAnswer(msg);
        }
        else {
          if (msg.source == "userImg") {
           var data = {};
           data.type = 'MSG';
           data.subType = 'image';
           data.body = msg.message;
           me.sdk.sendMessage(data);
          } else {
            me.sdk.sendMessage('MSG', msg.message);
          }
        }
      },
      'recommend-question': function(faqs) {
        this.messages.push({content: faqs, type: 0, source: 'robot'});
      },
      'recommend-answer': function(question, answer, id) {
        this.messages.push({message: question, source: 'user'});
        this.messages.push({content: [{title: question, text: answer, chatLogId: id, refers: 'advice'}], type: 6, source: 'robot'});
        this.scrollToBottom();
      },
      'robot-answer': function(msg) {
        this.messages.push({content: [{text:msg}], type: 2, source: 'robot'});
      },
      'request-switch': function() {
        this.messages.push({source: 'needService'});
        this.scrollToBottom();
      },
      'is-check':function (msg, entryType, companyCode, mailNo) {
        this.isCheck = msg;
        this.userId = this.isCheck.userId;
        this.userName = this.isCheck.userName;
        this.xcode = this.isCheck.xcode;
        this.companyCode = companyCode;
        this.mailNo = mailNo;
        if(entryType=="RENGONG"){
          this.$dispatch('need-service');
        }
      },
      'need-service': function () {
        this.tt = +new Date();
        this.initSkillGroup();
      },
      // 小二端踢出用户, 强制用户退出人工客服流程
      'need-leave': function () {
        var me = this;
        if (!me.isRobot && !me.isEvaluation) {
          me.sdk.logout(2, 10);
          me.showMask = true;
          me.createNewEvaluation();
          me.isRobot = true;
          me.sdk.destroy();
        } else {
          me.sdk.logout(2, 10);
          me.messages.push({message: "当前人工服务已结束", source: 'info'});
          me.isRobot = true;
          me.sdk.destroy();
        }
      },
      'feedback': function (feel, msg) {
        var me = this;
        me.showMask = false;
        me.isEvaluation = true;
        me.messages.push({message: "当前人工服务已结束", source: 'info'});
        if (feel == 'smile') {
          me.messages.push({message: "评价：满意", source: "user"});
        } else if (feel == 'normal') {
          me.messages.push({message: "评价：一般", source: "user"});
        } else if (feel == 'angry') {
          me.messages.push({message: "评价：不满意", source: "user"});
        }
        me.messages.push({message: "谢谢您的反馈，我们会继续努力~", source: 'ocs'});
        me.messages.push({message: "如无其他问题，点击浏览器窗口关闭即可退出客服", source: 'ocs'});
        me.scrollToBottom();
        me.submitNewEvaluation(msg);
      },
      'user-logout': function () {
        var me = this;
        me.sdk.logout(2, 10);
      },
      'send-info': function (msg, info) {
        var me = this;
        me.messages.pop();
        me.messages.push({message: msg, source:'userInfo'});
        me.messages.push({message: '旺旺：'+info.userName+'；电话：'+info.userTel+'；邮箱：'+info.userEmail, source:'userInfo'});

        // 提交保存数据
        var promise = lib.mtop.request({
          api: 'mtop.cainiao.delibird.portal.saveuserinfo',
          v: '1.0',
          data: {"userId": me.userId, "wangWang": info.userName, "phone":info.userTel, "mailBox": info.userEmail},
          appkey: '4272',
          ecode: 1,
          type: 'GET',
          dataType: 'jsonp',
          timeout: 20000
        });

        promise.then(function(resJson) {
          if(resJson.data.data=="true") {
              me.sdk.sendMessage('MSG', '用户已经完成信息填写');
          }
        }, function () {

        });
      },
      'urgent-order': function() {
        var me = this;

        // 提交保存数据
        var promise = lib.mtop.request({
          api: 'mtop.cainiao.delibird.portal.urgentcp',
          v: '1.0',
          data: {"companyCode": me.companyCode, "mailNo": me.mailNo},
          appkey: '4272',
          ecode: 1,
          type: 'GET',
          dataType: 'jsonp',
          timeout: 20000
        });

        promise.then(function(resJson) {
          if(resJson.data.errorCode){
            me.$dispatch('robot-answer', resJson.data.errorMsg);
          }
          else{
            me.$dispatch('robot-answer', '已为您申请加急派送，请保持电话畅通！');
          }
          me.scrollToBottom();
        }, function (resJson) {
          me.$dispatch('robot-answer', resJson.data.errorMsg);
        });
      },
      'question-evaluate': function(optType, chatLogId) {
        var me = this;

        // 提交保存数据
        var promise = lib.mtop.request({
          api: 'mtop.cainiao.delibird.portal.faqfeedbackcard',
          v: '1.0',
          data: {"optType": optType, "id": chatLogId, "companyCode": me.companyCode},
          appkey: '4272',
          ecode: 1,
          type: 'GET',
          dataType: 'jsonp',
          timeout: 20000
        });

        promise.then(function(resJson) {

        }, function (resJson) {

        });
      },
      'question-evaluate-advice': function(optType, chatLogId) {
        var me = this;

        // 提交保存数据
        var promise = lib.mtop.request({
          api: 'mtop.cainiao.delibird.portal.faqfeedback',
          v: '1.0',
          data: {"optType": optType, "id": chatLogId},
          appkey: '4272',
          ecode: 1,
          type: 'GET',
          dataType: 'jsonp',
          timeout: 20000
        });

        promise.then(function(resJson) {

        }, function (resJson) {

        });
      }
    },
    ready() {
      var me = this;
      window.onbeforeunload = function(){
        // 如果是人工服务, 又没有做出评价, 骚年不能走
        me.showMask = true;
        if (!me.isRobot && !me.isEvaluation) {
          me.sdk.logout(2, 10);
          me.createNewEvaluation();
          me.isRobot = true;
          me.sdk.destroy();
          return "请做出评价, 谢谢";
        }
      };
    },
    components: {
      DialogContainer,
      EditorContainer,
      CheckDialog
    }
  }
</script>

<style lang="less" scoped>
  @import "../assets/base";

  .im-container {
    border-right: 1px solid @borderGray;
    background: #f2f2f2;
    height: 100%;
    position: relative;
    margin-right: 300px;
  }

  .mask {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    overflow: hidden;
    z-index: 1000;
    background-color: #000;
    outline: 0;
    opacity: .5;
    filter: alpha(opacity=50);
    color: black;
  }
</style>



// WEBPACK FOOTER //
// ImContainer.vue?6d6dff6d